import {
  ENVIRONMENT,
  UBI_SERVICES_PUBLIC_ENDPOINT,
} from "../../../shared/constants";

export function setUbiPublicServicesApi(path: string) {
  return `${UBI_SERVICES_PUBLIC_ENDPOINT[ENVIRONMENT]}${path}`;
}
